import { Typography } from '@mui/material'
import React from 'react'
import style from './style2.module.css'
import { ISchool } from '../../interfaces/school.interface'

const SchoolFooter2 = (_props: { schoolDetails?: ISchool }) => {
  return (
    <div className={style.footerWrapper}>
      <div className={style.footerContent} style={{ width: '100%' }}>
        <div
          style={{
            width: '100%',
            padding: '20px 20px',
          }}
        >
          <div
            style={{
              position: 'relative',
            }}
          >
            {/*<div style={{ width: "100%" }}>*/}
            {/*  <Typography*/}
            {/*    align={"center"}*/}
            {/*    style={{ color: "#fff" }}*/}
            {/*    variant={"h5"}*/}
            {/*  >*/}
            {/*    <b> {props.schoolDetails?.name}</b>*/}
            {/*  </Typography>*/}
            {/*  <Typography*/}
            {/*    variant={"body2"}*/}
            {/*    align={"center"}*/}
            {/*    style={{ color: "#fff" }}*/}
            {/*  >*/}
            {/*    {props.schoolDetails?.tagline}*/}
            {/*  </Typography>*/}
            {/*</div>*/}
            <div style={{ marginTop: '20px' }}>
              <Typography
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: 500,
                  fontSize: ' 20px',
                  lineHeight: '29px',
                  letterSpacing: '-0.045em',
                  color: '#e6e4e3',
                  margin: 0,
                  textAlign: 'center',
                }}
              >
                Built with pledre.com
              </Typography>
              <Typography
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '18px',
                  margin: 0,
                  letterSpacing: '-0.005em',
                  color: '#e6e4e3',
                  textAlign: 'center',
                }}
              >
                Create your own online academy today
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SchoolFooter2
